const FULLSTORY_CONSENT_KEY = "trackingConsent"
const ANALYTICS_CONSENT_COOKIE = "cookie_consent_analytics"
const FULLSTORY_SCRIPT_ID = "fullstory-loader-script"

declare global {
  interface Window {
    FS?: (...args: unknown[]) => void
    _fs_host?: string
    _fs_script?: string
    _fs_org?: string
    _fs_namespace?: string
  }
}

const hasAnalyticsConsent = (): boolean => {
  try {
    const localConsent = localStorage.getItem(FULLSTORY_CONSENT_KEY)
    if (localConsent === "granted" || localConsent === "true") {
      return true
    }

    const cookieConsent = document.cookie
      .split(";")
      .map(part => part.trim())
      .find(part => part.startsWith("cookie_consent_analytics="))

    if (!cookieConsent) {
      return false
    }

    const cookieValue = cookieConsent.split("=")[1]
    return cookieValue === "true" || cookieValue === "granted"
  } catch {
    return false
  }
}

const setAnalyticsConsentCookie = (value: "granted" | "revoked"): void => {
  try {
    const cookieValue = value === "granted" ? "granted" : "false"
    const maxAge = value === "granted" ? 31536000 : 0
    document.cookie = `${ANALYTICS_CONSENT_COOKIE}=${cookieValue}; path=/; max-age=${maxAge}; SameSite=Lax`
  } catch {
    // Ignore cookie write failures (strict browser policies).
  }
}

export const grantAnalyticsConsent = (): void => {
  try {
    localStorage.setItem(FULLSTORY_CONSENT_KEY, "granted")
  } catch {
    // Ignore storage failures (private mode or strict browser policies).
  }
  setAnalyticsConsentCookie("granted")
  initFullStory()
}

export const revokeAnalyticsConsent = (): void => {
  try {
    localStorage.setItem(FULLSTORY_CONSENT_KEY, "revoked")
  } catch {
    // Ignore storage failures (private mode or strict browser policies).
  }
  setAnalyticsConsentCookie("revoked")
}

export const initFullStory = (): void => {
  try {
    if (typeof window === "undefined" || typeof document === "undefined") {
      return
    }

    if (!hasAnalyticsConsent()) {
      return
    }

    if (document.getElementById(FULLSTORY_SCRIPT_ID)) {
      return
    }

    window._fs_host = "fullstory.com"
    window._fs_script = "edge.fullstory.com/s/fs.js"
    window._fs_org = "o-1ZJA1V-na1"
    window._fs_namespace = "FS"

    const script = document.createElement("script")
    script.id = FULLSTORY_SCRIPT_ID
    script.async = true
    script.crossOrigin = "anonymous"
    script.src = `https://${window._fs_script}`
    script.onerror = () => {
      console.info("[analytics] FullStory script blocked or failed to load")
    }
    document.head.appendChild(script)
  } catch (error) {
    console.info("[analytics] FullStory init skipped due to runtime restriction", error)
  }
}
